import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['showIcon', 'hideIcon']

  connect () {
    const input = this.element.querySelector('input[type="password"], input[type="text"]')
    if (!input) return

    const wrapper = input.parentElement
    wrapper.style.position = 'relative'

    const button = this.element.querySelector('.password-toggle-btn')
    if (button) wrapper.appendChild(button)
  }

  toggle () {
    const input = this.element.querySelector('input[type="password"], input[type="text"]')
    if (!input) return

    const isPassword = input.type === 'password'
    input.type = isPassword ? 'text' : 'password'
    this.showIconTarget.classList.toggle('hidden', !isPassword)
    this.hideIconTarget.classList.toggle('hidden', isPassword)
  }
}
